export const PAGINATION_DEFAULTS = {
  limit: 10,
  offset: 0,
};

export const PAGINATION_THOUSAND_DEFAULTS = {
  limit: 1000,
  offset: 0,
};

export const PAGINATION_10K_DEFAULTS = {
  limit: 10000,
  offset: 0,
};

export const ALLOWED_DATA_FILE_MIME_TYPES = [
  'text/csv',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];

export const AUTH_TOKENS_COOKIE_ATTRIBUTES = (() => {
  // get dot prefixed domain for cookie domain attribute i.e '.emodo.io'
  const hostname = window.location.hostname;
  const domain = hostname === 'localhost' ? 'localhost' : '.' + hostname;
  return {
    path: '/',
    domain: domain,
  };
})();

export const AUTH_TOKENS_COOKIE_NAME = 'auth_tokens';

export const ACTIVE_ACCOUNT_COOKIE_NAME = 'active_account';
export const ACTIVE_ACCOUNT_COOKIE_ATTRIBUTES = (() => {
  // get dot prefixed domain for cookie domain attribute i.e '.emodo.io'
  const hostname = window.location.hostname;
  const domain = hostname === 'localhost' ? 'localhost' : '.' + hostname;
  return {
    path: '/',
    domain: domain,
  };
})();

export const EMODO_DEAL_DSP_ID = 5;

export const MAX_LG_POIS = 15000;

export const COMMON_INPUT_CHANGE_DEBOUNCE = 300;
